export default {
  name: 'user-survey-response',
  translationKey: 'user-survey-response-module',
  routePrefix: 'user-survey-response',
  routeNamePrefix: 'user-survey-response',
}
